import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_live_algae_cooking_club: FaireBrandEntity = {
  token: "b_live_algae_cooking_club",
  type: "brand",
  name: "Algae Cooking Club",
  minimumOrderDollars: 34,
  tags: ["live-shopping", "food"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
